import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {constantsErrorMessages} from "../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import SalaryTable from "../../../components/UI/table/orders/organization/economic/SalaryTable";
import WorkerService from "../../../API/orders/job/WorkerService";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import {Button} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ReportTable from "../../../components/UI/table/orders/organization/economic/ReportTable";
import ReportRemainsTable from "../../../components/UI/table/orders/organization/economic/ReportRemainsTable";

const Salary = () => {
    const startInitValue = dayjs().date(1)
    const [tab, setTab] = useState(1);
    const [alertData, setAlertData] = useState({});
    const [workers, setWorkers] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const [date, setDate] = useState({
        salary: {
            startShipped: startInitValue,
            finishShipped: null,
            startCompletion: null,
            finishCompletion: null,
            startPaid: null,
            finishPaid: null
        },
        reportRemains: {
            startShipped: startInitValue,
        },
        report: {
            startShipped: startInitValue,
            finishShipped: null,
            startCompletion: null,
            finishCompletion: null,
            startPaid: null,
            finishPaid: null
        }
    });

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (typeof nextState !== 'function' && nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(`organization/salary+${tab}`, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const savedTab = pagesData["organization/salary"]?.tab
        const pageSize = pagesData[`organization/salary+${savedTab}`]?.pageSize
        savedTab && setTab(savedTab)
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }

    useEffect(() => {
        getStartPageSize()
        WorkerService.getWorkers().then(function (response) {
            setWorkers(response.data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const renderContent = () => {
        switch (tab) {
            case 1:
                return <SalaryTable
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    startInitValue={startInitValue}
                    workers={workers}
                    date={date.salary}
                    setDate={setDate}
                />
            case 2:
                return <ReportRemainsTable
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    startInitValue={startInitValue}
                    workers={workers}
                    date={date.reportRemains}
                    setDate={setDate}
                />
            case 3:
                return <ReportTable
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    startInitValue={startInitValue}
                    date={date.report}
                    setDate={setDate}
                />
        }
    }
    const handleChangeTab = (tab) => {
        setTab(tab)
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[`organization/salary+${tab}`]?.pageSize || 100
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
        EditLocalStoragePagesData(`organization/salary`, "tab", tab)
    }
    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"Заработная плата"}
                path={[
                    {name: "Главная", href: "/"},
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column", gap: "30px"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        Заработная плата
                    </Typography>
                </Box>
                <Box sx={{display: "flex", flexDirection: "column", gap: "30px"}}>
                    <ButtonGroupTabBar activeTab={tab}>
                        <Button tabIndex={1} onClick={(e) => handleChangeTab(1)}>
                            <CheckIcon/>Заработная плата
                        </Button>
                        <Button tabIndex={2} onClick={(e) => handleChangeTab(2)}>
                            <CheckIcon/>Отчёт по остаткам зп
                        </Button>
                        <Button tabIndex={3} onClick={(e) => handleChangeTab(3)}>
                            <CheckIcon/>Отчёт по зп
                        </Button>
                    </ButtonGroupTabBar>
                    {renderContent()}
                </Box>
            </Box>
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default Salary;